/**
 * One element of a page, cut out of its HTML as text. A Worker has no DOM, so
 * the page designer and the live page's time both work on the document as a
 * string, cut by tag depth.
 */
export interface Block {
  start: number;
  end: number;
  block: string;
}

/** The block that starts at `open` and ends at its own closing `tag`, or null. */
export function cutAt(html: string, open: string, tag: string, from = 0): Block | null {
  const start = html.indexOf(open, from);
  if (start < 0) return null;
  const re = new RegExp(`<${tag}\\b|</${tag}\\s*>`, "gi");
  re.lastIndex = start;
  let depth = 0;
  let m: RegExpExecArray | null;
  while ((m = re.exec(html))) {
    depth += m[0].startsWith("</") ? -1 : 1;
    if (depth === 0) {
      const end = m.index + m[0].length;
      return { start, end, block: html.slice(start, end) };
    }
  }
  return null;
}
